export default {
  print: 'Imprimir',
  pdf: 'Baixar PDF',
  close: 'Fechar',
  fullscreen: 'Tela cheia',
  empty: 'Não há informações para exibir neste documento.',
  error: 'Não foi possível abrir o documento agora. Tente novamente.',
  pdfFailed: 'Não foi possível gerar o PDF agora. Tente novamente.',
  pdfPage: 'Página {page} de {pages}',
};
